import Vue from 'vue';
import Vuex from 'vuex';
import { FeathersVuex } from '../feathers-client';
import auth from './store.auth';
import moment from 'moment';

Vue.use(Vuex);
Vue.use(FeathersVuex);

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  false,
  // Only include .js files (prevents duplicate imports`)
  /.js$/
);
const servicePlugins = requireModule
  .keys()
  .map((modulePath) => requireModule(modulePath).default);

const store = new Vuex.Store({
  state: {

    modalFechas: false,
    dialogVarSelectedRangueFecha: null,
    selectedRangueFecha: [
      moment().startOf('month').format('DD-MM-YYYY'),
      moment().format('DD-MM-YYYY'),
    ],
    disabledFecha: moment().format('YYYY-MM-DD'),
    //
    globalMonth: new Date().toISOString().substr(0, 7),
    globalMonthTo: new Date().toISOString().substr(0, 7),
    store_modulos: [],
    snackbars: [],
    globalLoading: false,
    revision_contrato_deudor: null,
    revision_complementos_deudor: null,
    revision_evaluacion_deudor: null,
    revision_referencias_deudor: null,
    /** */
    modulos: [
      {
        icono: 'mdi-clipboard-edit-outline',
        titulo: 'Precalificaciones incompletas',
        url: '/precalificaciones-incompletas',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-edit',
        titulo: 'Precalificaciones completas',
        url: '/precalificaciones-completadas',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-text-play',
        titulo: 'En revisión',
        url: '/gestiones-en-revision',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-text-clock',
        titulo: 'Con pendientes',
        url: '/gestiones-con-pendientes',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-text-clock',
        titulo: 'Con rectificaciones',
        url: '/gestiones-con-rectificaciones',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-account',
        titulo: 'Con compromiso de pago',
        url: '/gestiones-con-compromiso-de-pago',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-check',
        titulo: 'Para aprobación',
        url: '/gestiones-listas-para-aprobacion',
        tipo: 'menuPrincipalTopSection'
      },
      {
        icono: 'mdi-clipboard-check-multiple-outline',
        titulo: 'Concluidas',
        url: '/gestiones-concluidas',
        tipo: 'menuPrincipalTopSection'
      },
      {
        titulo: 'Documentos pendientes por compromiso de pago',
        descripcion:
          'Listado de evaluaciones que tiene aprobado el compromiso de pago y están pendientes de presentar la documentación',
        url: '/documentos-pendientes-con-compromiso-de-pago',
        icono: 'mdi-clipboard-account-outline',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-clipboard-flow',
        titulo: 'Seguimiento de gestión',
        descripcion: 'Listado que muestra el estado de cada una de las evaluaciones',
        url: '/seguimiento-gestion',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-chart-bar',
        descripcion:
          'Listado de precalificaciones que la agente de comercio no ha completado',
        titulo: 'Reportes',
        url: '/Reportes',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-account-key',
        titulo: 'Agentes de comercio',
        url: '/agentes-de-comercio',
        descripcion:
          'Gestiona los accesos de las agentes de comercio a la app móvil',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-account-key-outline',
        titulo: 'Usuarios administrativos',
        url: '/usuarios-administrativos',
        descripcion: 'Crea y edita usuarios administrativos',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        titulo: 'Historico',
        descripcion: 'Búsqueda de gestiones en el archivo histórico',
        url: '/seguimiento-gestion-historico',
        icono: 'mdi-history',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-face-recognition',
        titulo: 'Canal Web Reconocimiento',
        descripcion: 'Gestiones creadas desde el canal web de reconocimiento facial',
        url: '/gestiones-reconocimiento-facial',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-currency-usd',
        titulo: 'Control de Costos AWS',
        descripcion: 'Comparativo de costos AWS estimados vs. modelos de facturación del Canal Web Reconocimiento',
        url: '/costos-canal-reconocimiento',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-timer-outline',
        titulo: 'Tiempos de Evaluación',
        descripcion: 'Tiempos por etapa y total del Canal Web Reconocimiento Facial',
        url: '/tiempos-evaluacion-canal-reconocimiento',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
      {
        icono: 'mdi-format-list-checks',
        titulo: 'Servicios y Estado de Evaluaciones',
        descripcion: 'Paso actual y servicios de verificación usados por cada evaluación del Canal Web Reconocimiento (sin costos)',
        url: '/servicios-evaluacion-canal-reconocimiento',
        tipo: 'menuPrincipalOpcionesAbajo'
      },
    ],
  },
  mutations: {
    SET_SNACKBAR(state, snackbar) {
      state.snackbars = state.snackbars.concat(snackbar);
    },
    CLOSE_SNACKBAR(state, snackbar_index) {
      console.log(state.snackbars);
      console.log('state.snackbars before');
      state.snackbars.splice(snackbar_index, 1);
      console.log('state.snackbars after');
    },

    SET_MODAL_FECHAS(state, value) {
      state.modalFechas = value;
    },
    SET_DIALOG_VAR_SELECTED_RANGUE_FECHA(state, value) {
      state.dialogVarSelectedRangueFecha = value;
      // Update the formatted date range when the raw date range changes
      state.selectedRangueFecha = [
        moment(value[0]).format('DD-MM-YYYY'),
        moment(value[1]).format('DD-MM-YYYY'),
      ];
    },
    SET_SELECTED_RANGUE_FECHA(state, value) {
      state.selectedRangueFecha = value;
    },
    SET_DISABLED_FECHA(state, value) {
      state.disabledFecha = value;
    },
  },
  actions: {

    setModalFechas({ commit }, value) {
      commit('SET_MODAL_FECHAS', value);
    },
    setDialogVarSelectedRangueFecha({ commit }, value) {
      commit('SET_DIALOG_VAR_SELECTED_RANGUE_FECHA', value);
    },
    setSelectedRangueFecha({ commit }, value) {
      commit('SET_SELECTED_RANGUE_FECHA', value);
    },
    setDisabledFecha({ commit }, value) {
      commit('SET_DISABLED_FECHA', value);
    },
    saveDateRange({ commit }, value) {
      commit('SET_DIALOG_VAR_SELECTED_RANGUE_FECHA', value);
    },
    //
    fnGetBorder() {
      return '#EEFF41';
    },
    setSnackbar({ commit }, snackbar) {
      snackbar.color = snackbar.color || 'green';
      commit('SET_SNACKBAR', snackbar);
    },
    closeSnackbar({ commit }, snackbar_index) {
      console.log(snackbar_index);
      commit('CLOSE_SNACKBAR', snackbar_index);
    },
  },
  getters: {
    getModalFechas: (state) => state.modalFechas,
    getDialogVarSelectedRangueFecha: (state) => state.dialogVarSelectedRangueFecha,
    getSelectedRangueFecha: (state) => state.selectedRangueFecha,
    getDisabledFecha: (state) => state.disabledFecha,
    getFirstDay: (state) => {
      const split1 = state.selectedRangueFecha[0].split('-');
      return new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
    },
    getLastDay: (state) => {
      const split2 = state.selectedRangueFecha[1].split('-');
      return new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
    },
  },
  modules: {},
  plugins: [...servicePlugins, auth],
});

export default store;
